import AddImageCard from './AddImageCard';
export default AddImageCard;
